import { render, staticRenderFns } from "./DataTableFooter.vue?vue&type=template&id=08c2f976&"
import script from "./DataTableFooter.vue?vue&type=script&lang=js&"
export * from "./DataTableFooter.vue?vue&type=script&lang=js&"
import style0 from "./DataTableFooter.vue?vue&type=style&index=0&module=true&lang=module.css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports